export class VersionControlResponse{
    lockapp : boolean;
    message: string;
    urlstore: string;
    error: number;
    videoLiveTime: number;

    constructor(lockapp: boolean, message: string, urlstore: string, error: number, videoLiveTime: number){
        this.lockapp = lockapp;
        this.message = message;
        this.urlstore = urlstore;
        this.error = error;
        this.videoLiveTime = videoLiveTime
    }
}